import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ReInviteIcon24 = (props: SvgProps) => <Svg
  width={24}
  height={24}
  fill='none'
  {...props}
>
  <Path
    d="M18 9V4.85714C18 4.38376 17.6269 4 17.1667 4H3.83333C3.3731 4 3 4.38376 3 4.85714V15.1429C3 15.6162 3.3731 16 3.83333 16H8.5M3 6L10.5 10L18 6M13 17C12.9997 16.1192 13.2901 15.2629 13.8261 14.564C14.3622 13.8651 15.114 13.3627 15.9648 13.1347C16.8157 12.9068 17.7179 12.966 18.5316 13.3033C19.3453 13.6406 20.0249 14.237 20.465 15M18 15H20.5V12.5M21 17C21.0003 17.8808 20.7099 18.7371 20.1738 19.436C19.6377 20.1349 18.886 20.6373 18.0351 20.8653C17.1843 21.0932 16.282 21.034 15.4684 20.6967C14.6547 20.3594 13.975 19.763 13.535 19M16 19H13.5V21.5"
    stroke={props.color ?? '#0058AD'}
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</Svg>;

export default ReInviteIcon24;
